var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qtrust--modal row",on:{"click":_vm.closeModal}},[_c('div',{class:_vm.boxClass,style:(_vm.boxStyle),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }